import { render } from "./HeaderFrame.vue?vue&type=template&id=15b040f0&scoped=true"
import script from "./HeaderFrame.vue?vue&type=script&lang=js"
export * from "./HeaderFrame.vue?vue&type=script&lang=js"

import "./HeaderFrame.vue?vue&type=style&index=0&id=15b040f0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\bp-kmiyajima\\Documents\\Projects\\noritz-protal\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b040f0"]])

export default __exports__